export default __webpack_public_path__ + "static/media/chaos_logo_transparent.c97f1dcf.png";